import React from "react";

export const SITE_URL = "https://clinixport-global.emergent.host";

// React 19 hoists <title>, <meta> and <link> into <head>.
export default function Seo({ title, description, path = "", image = "/clinixport-logo.png", keywords, jsonLd }) {
  const url = SITE_URL + path;
  const img = image.startsWith("http") ? image : SITE_URL + image;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Clinixport Global" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </>
  );
}
